import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { Stethoscope, Lock } from "lucide-react";

export default function DoctorLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/doctor");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }

  function fillDemo() {
    setEmail("admin@drprofile.com");
    setPassword("admin123");
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0F172A] via-[#0F172A] to-slate-900 grid place-items-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-slate-300 hover:text-white justify-center mb-6">
          <div className="w-9 h-9 rounded-xl bg-emerald-500 grid place-items-center font-bold text-slate-900">DP</div>
          <span className="font-display font-bold">Dr Profile</span>
        </Link>
        <div className="bg-white rounded-3xl shadow-2xl p-8">
          <div className="w-12 h-12 rounded-2xl bg-emerald-100 text-emerald-700 grid place-items-center mx-auto"><Stethoscope size={22} /></div>
          <h1 className="text-2xl font-display font-bold text-slate-900 text-center mt-4">Doctor sign in</h1>
          <p className="text-sm text-slate-500 text-center mt-1">Private dashboard — authorised staff only</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block">
              <div className="text-xs text-slate-600 font-medium mb-1.5">Email</div>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input" data-testid="doctor-login-email-input" />
            </label>
            <label className="block">
              <div className="text-xs text-slate-600 font-medium mb-1.5">Password</div>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input" data-testid="doctor-login-password-input" />
            </label>
            <button
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 disabled:opacity-50 text-white font-semibold rounded-xl px-5 py-3"
              data-testid="doctor-login-submit-button"
            >
              <Lock size={14} /> {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <div className="flex items-center justify-between mt-4 text-sm">
            <Link to="/doctor/forgot-password" className="text-slate-600 hover:text-slate-900">Forgot password?</Link>
            <button onClick={fillDemo} className="text-emerald-700 hover:text-emerald-800 font-medium" data-testid="demo-fill-btn">Use demo credentials</button>
          </div>
        </div>
        <Link to="/" className="block text-center text-sm text-slate-400 hover:text-slate-200 mt-5">← Back to public site</Link>
      </div>
      <style>{`.input{width:100%;padding:.7rem .9rem;border:1px solid #CBD5E1;border-radius:.75rem;background:#fff;color:#0F172A;font-size:.95rem;}
      .input:focus{outline:none;border-color:#0D9488;box-shadow:0 0 0 3px rgb(13 148 136 / 0.15)}`}</style>
    </div>
  );
}
